export default "__VITE_ASSET__Ctn8Imrr__"